import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

// vue-slider-component 4 (Vue 3, clientapp ile aynı; Aşama 4.8); v-model `modelValue`/`update:modelValue`.
export default {
  install(app) {
    app.component("vue-slider", VueSlider)
  }
}
